module.exports = __webpack_public_path__ + "assets/images/scholarship-lg.aac796dd76e9c4353f6420f3ebed0954.svg";